var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle"},[(!_vm.transfering)?_c('img',{staticClass:"pointer",attrs:{"src":require('../../assets/icons/arrow.svg')}}):_vm._e(),(_vm.transfering)?_c('div',{staticClass:"loading-dots"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }